import { IPartner } from 'clickNgo/entities/partner/models'
import { useGetFormData } from 'cng-common/features/form'

import { PartnerDataFormKeys } from '../../../configs'

interface IUseLegalInfoMandatoryAttachmentsParams {
  hasActiveAgreement: boolean
}

export const useLegalInfoMandatoryAttachments = ({
  hasActiveAgreement,
}: IUseLegalInfoMandatoryAttachmentsParams) => {
  const [{ formData, modifiedFields }] = useGetFormData<IPartner>(PartnerDataFormKeys.LegalInfo)

  const isAmericanPartner = formData?.legalCountry === 'USA'

  const isAttachmentRequired = Boolean(
    hasActiveAgreement && !isAmericanPartner && modifiedFields.length
  )

  return { isAttachmentRequired }
}
